module.exports = __webpack_public_path__ + "static/img/banner-fixed2.f087519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-fixed2.jpg
// module id = nVD1
// module chunks = 1